<!--<nav>
  <ul class="pagination">
    <li class="page-item" [class.disabled]="currentPage === 1">
      <a class="page-link" (click)="changePage(currentPage - 1)">Previous</a>
    </li>
    <li *ngFor="let page of [].constructor(totalPages); let i = index" 
        class="page-item" 
        [class.active]="isPageActive(i + 1)">
      <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
    </li>
    <li class="page-item" [class.disabled]="currentPage === totalPages">
      <a class="page-link" (click)="changePage(currentPage + 1)">Next</a>
    </li>
  </ul>
</nav>-->

<nav aria-label="Page navigation">
  <ul class="pagination justify-content-end">
    <li class="page-item" [class.disabled]="currentPage === 1">
      <a class="page-link" (click)="changePage(currentPage - 1)">Previous</a>
    </li>
    <li *ngFor="let page of visiblePages()"
        class="page-item"
        [class.active]="isPageActive(page)">
      <a class="page-link" (click)="changePage(page)">{{ page }}</a>
    </li>
    <li class="page-item" [class.disabled]="currentPage === totalPages">
      <a class="page-link" (click)="changePage(currentPage + 1)">Next</a>
    </li>
  </ul>
</nav>
